import { SWITCH_REDIRECTING_TO_DS_MODAL} from '../types';

const initialState = {
  currentItem: {},
  showRedirectingModal: false,
};

const redirectingToDocuSignReducer = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_REDIRECTING_TO_DS_MODAL:
      return {
        currentItem: action.payload,
        showRedirectingModal: !state.showRedirectingModal,
      };

    default:
      return state;
  }
};

export default redirectingToDocuSignReducer;